import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import ConnectivityGroup from "../../../../groups/ConnectivityGroup";

class MetricMaybeAvailableRate extends MetricBase {
    constructor() {
        super({
            field: "metric_maybe_available_rate",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.maybe_available_rate.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.maybe_available_rate.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.maybe_available_rate.tooltip"),
            group: new ConnectivityGroup(),
        });
    }
}

export default MetricMaybeAvailableRate;